import styled from 'styled-components'

export const SelectArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
`
